import { caseTaskSchema } from "@/components/Forms/schema/addCaseTasksSchema.ts";
import { dtMetaSchema } from "@/components/Forms/schema/dtMetaSchema.ts";
import { mediaSchema } from "@/components/Forms/schema/mediaSchema.ts";
import { mrtCaseSchema } from "@/components/Forms/schema/mrtCaseSchema.ts";
import { noteSchema } from "@/components/Forms/schema/note/noteSchema.ts";
import { type Relationships, createResourceCollectionSelector } from "jsonapi-zod-query";

export const caseTaskCollectionResourceSelector = createResourceCollectionSelector({
    type: "caseTask",
    attributesSchema: caseTaskSchema,
    documentMetaSchema: dtMetaSchema,
    relationships: {
        case: {
            relationshipType: "one",
            include: {
                type: "case",
                attributesSchema: mrtCaseSchema,
            },
        },
        notes: {
            relationshipType: "many",
            include: {
                type: "note",
                attributesSchema: noteSchema,
                relationships: {
                    media: {
                        relationshipType: "many",
                        include: {
                            type: "media",
                            attributesSchema: mediaSchema,
                        },
                    },
                } satisfies Relationships,
            },
        },
    },
});

export type CaseTasksDocument = ReturnType<typeof caseTaskCollectionResourceSelector>;
export type CaseTask = CaseTasksDocument["data"][number];
export type CaseTaskWithDueDate = CaseTask & {
    dueDate: Date;
    overdue: boolean;
};
